import React from "react";
import MKBox from "components/MKBox";
import { Link } from "react-router-dom";
// ✅ Ensure path is correct
import logo from "assets/Images/logo.png";
// ✅ Import prop-types
import PropTypes from "prop-types";

export default function Logo({ height = 40, to = "/" }) {
  return (
    <Link to={to}>
      <MKBox
        component="img"
        src={logo}
        alt="Brand Logo"
        sx={{
          height: { xs: height - 8, md: height },
          maxWidth: 180,
          objectFit: "contain",
          cursor: "pointer",
        }}
      />
    </Link>
  );
}

// ✅ Add prop validation to silence ESLint
Logo.propTypes = {
  height: PropTypes.number,
  to: PropTypes.string,
};
